require('./bootstrap');

import Alpine from "alpinejs";
import slug from "alpinejs-slug";
import intersect from '@alpinejs/intersect';

Alpine.plugin(intersect);
Alpine.plugin(slug);

window.Alpine = Alpine;
Alpine.start();

import WOW from 'wow.js'
const wow = new WOW({
  boxClass: 'wow',
  animateClass: 'animated',
  offset: 0,
  live: true
});
